import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function En(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="fxif">
                1.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxif')}
            </Typography>
            <p><strong>{translate('fxif')}</strong> returns 1 if the test is true, returns 2 if the test is false.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is the condition.</td>
                                <td>Day() = 1</td>
                            </tr>
                            <tr>
                                <td>{translate('results')}1<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>As result 1.</td>
                                <td>"Beginning of the month"</td>
                            </tr>
                            <tr>
                                <td>{translate('results')}2<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>As result 2.</td>
                                <td>""</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. If( Day() = 1 , "Beginning of the month" , "" ) returns "" if today is not the 1st of the month and vice versa.</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxcase">
                2.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxcase')}
            </Typography>
            <p><strong>{translate('fxcase')}</strong> evaluates each condition in order from left to right and, when a true condition is found, returns the value specified in the result for that condition. If none of the conditions are true, the default result will be returned.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('condition')},{translate('results')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="array" />
                                </td>
                                <td>Is the condition and the result returned if the condition is true.</td>
                                <td>[[Day() ≤ 10 , "Early"] , [Day() ≥ 11 && Day() ≤ 20 , "Mid"]]</td>
                            </tr>
                            <tr>
                                <td>{translate('number')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="any" />
                                </td>
                                <td>Any value.</td>
                                <td>"Late"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="any" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. Case( [[Day() ≤ 10 , "Early"] , [Day() ≥ 11 && Day() ≤ 20 , "Mid"]] , "Late" ) returns "Early" if today's date is small greater than or equal to 10, returns "Mid" if today is greater than 10 and less than or equal to 20, otherwise returns "Late".</div>
                </div>
            </ul>
            <Typography variant="h5" gutterBottom id="fxisempty">
                3.&nbsp;<span className="material-symbols-outlined">function</span>&nbsp;{translate('fxisempty')}
            </Typography>
            <p><strong>{translate('fxisempty')}</strong> returns (true) if empty or else if an error occurs, otherwise returns (false).</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('text')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Is any string.</td>
                                <td>"text"</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="number" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <div className='results'>
                    <div>1. IsEmpty("text") returns false</div>
                    <div>2. IsEmpty("") returns true</div>
                </div>
            </ul>
        </Box>
    );
}
export default withTranslate(En);